import React from 'react';
import InputTextComp from "@components/UI/InputText/Index.jsx";
import { SaveProcesso } from "@services/Processo/Index.jsx";
import { useForm } from 'react-hook-form';
import ButtonComp from "@components/UI/Button/Index.jsx";
import SweetAlert from "@components/Feedback/SweetAlert/Index.jsx";
import SelectOptionComp from '@components/UI/SelectOption/Index.jsx';
import CheckBoxComp from '@components/UI/CheckBox/Index.jsx';

const Filter = ({ onSave }) => {

    const { register, handleSubmit, watch, setValue } = useForm();

    const onSubmit = async (data) => {
        try {
            SweetAlert.loading();

            const payload = {

            };

            const result = await SaveProcesso(payload);

            SweetAlert.success('Consulta Concluída!', 'Os dados foram encontrados com sucesso.');

            onSave({ ...result });

        } catch (error) {

            let errorMessage = 'Ocorreu um problema ao tentar consultar os dados.';


            SweetAlert.errorHTML('Erro ao consultar', errorMessage);
            console.error(error);
        }
    };

    return (
        <form onSubmit={handleSubmit(onSubmit)} className='form'>
            <div className="row py-3">

                {/* Coluna Esquerda */}
                <div className='col-8 col-md-8'>

                    <InputTextComp
                        label="Nº Da Solicitação"
                        name="numSolicitacao"
                        {...register("numSolicitacao")}
                        placeholder={"Preencher com o número da solicitação"}
                        hoverMessage="Preencher com o número da solicitação"
                        maxLength={255}
                        required={true}
                    />

                    <div className='d-flex'>
                        <div className='col-md-6'>
                            <SelectOptionComp
                                label="Data Inicial"
                                //options={}
                                value={watch("dataInicial")}
                                onChange={(selected) => setValue("dataInicial", selected)}
                                placeholder={"Selecionar"}
                                hoverMessage="Selecionar uma data inicial"
                            />
                        </div>

                        <div className='col-md-6'>
                            <SelectOptionComp
                                label="Data Final"
                                //options={}
                                value={watch("dataFinal")}
                                onChange={(selected) => setValue("dataFinal", selected)}
                                placeholder={"Selecionar"}
                                hoverMessage="Selecionar uma data final"
                            />
                        </div>
                    </div>

                    <SelectOptionComp
                        label="Unidade"
                        //options={}
                        value={watch("unidade")}
                        onChange={(selected) => setValue("unidade", selected)}
                        placeholder={"Selecionar uma unidade"}
                        hoverMessage="Selecionar uma unidade"
                    />

                </div>

                {/* Coluna Direita */}
                <div className='col-md-4'>
                    <h2 className='px-2'>Status</h2>

                    <CheckBoxComp
                        label={<span className="large"> Solicitação criada </span>}
                        title={"Filtrar solicitações que estão com o status de criada"}
                        className={"mt-1"}
                    />

                    <CheckBoxComp
                        label={<span className="large"> Solicitação Enviada </span>}
                        title={"Filtrar solicitações que estão com o status de enviada"}
                        className={"mt-1"}
                    />

                    <CheckBoxComp
                        label={<span className="large"> Solicitação Agendada </span>}
                        title={"Filtrar solicitações que estão com o status de agendada"}
                        className={"mt-1"}
                    />

                    <CheckBoxComp
                        label={<span className="large"> Envio Resposta </span>}
                        title={"Filtrar solicitações que estão com o status de envio resposta"}
                        className={"mt-1"}
                    />

                    <CheckBoxComp
                        label={<span className="large"> Envio Plano de Ação </span>}
                        title={"Filtrar solicitações que estão com o status de envio plano de ação"}
                        className={"mt-1"}
                    />

                    <CheckBoxComp
                        label={<span className="large"> Atualização da Solicitação </span>}
                        title={"Filtrar solicitações que estão com o status de atualização"}
                        className={"mt-1"}
                    />

                    <CheckBoxComp
                        label={<span className="large"> Consulta Solicitação </span>}
                        title={"Filtrar solicitações que estão com o status de consulta"}
                        className={"mt-1"}
                    />

                    <CheckBoxComp
                        label={<span className="large"> Relatório Enviado </span>}
                        title={"Filtrar solicitações que estão com o status de relatório enviado"}
                        className={"mt-1"}
                    />

                    <CheckBoxComp
                        label={<span className="large"> Auditoria Encerrada </span>}
                        title={"Filtrar solicitações que estão com o status de auditoria encerrada"}
                        className={"mt-1"}
                    />

                </div>

                <div className="col-12 col-md-12 d-flex flex-wrap justify-content-end mt-4">
                    <ButtonComp
                        title="Aplicar filtro"
                        type="submit"
                        buttonColor="#2b97be"
                        classnameIcon="fa-solid fa-filter"
                        hoverMessage={"Botão para aplicar o filtro da consulta"}
                    />

                    <ButtonComp
                        title="Limpar filtro"
                        type="submit"
                        buttonColor="#125578"
                        classnameIcon="fa-regular fa-circle-xmark"
                        hoverMessage={"Botão para limpar os campos de filtros preenchidos"}
                    />

                    <ButtonComp
                        title="Exportar"
                        type="submit"
                        buttonColor="#495058"
                        classnameIcon="fa-solid fa-file-export"
                        hoverMessage={"Botão para limpar os campos de filtros preenchidos"}
                    />
                </div>

            </div>
        </form>
    );
};

export default Filter;
